

window.equalizeProductTextHeight = function() {
  const elements = document.querySelectorAll(".product-card .text-block");
  let maxHeight = 0;

  elements.forEach(el => el.style.height = "auto");

  elements.forEach(el => {
    maxHeight = Math.max(maxHeight, el.offsetHeight);
  });

  elements.forEach(el => {
    el.style.height = maxHeight + "px";
  });
}

window.addEventListener("load", window.equalizeProductTextHeight);
window.addEventListener("resize", window.equalizeProductTextHeight);


window.updatePrice = function () {
    const container = document.querySelector('.discount__variantOption_wrapp .selected-option input:checked');
    if (container) {
        const price_of_main_prod = container.getAttribute('data-variant-price');

        const addToCartBtn = document.querySelector('.add-to-cart-button .add-to-cart-text__content');
        if (!addToCartBtn) return;

        const oldSpan = addToCartBtn.querySelector('.new-price-span');
        if (oldSpan) oldSpan.remove();
        const newSpanPrice = document.createElement('span');
        newSpanPrice.classList.add('new-price-span');
        newSpanPrice.textContent = price_of_main_prod;
        addToCartBtn.innerHTML = 'Add to cart';
        addToCartBtn.appendChild(newSpanPrice);

        console.log("price_of_main_prod", price_of_main_prod);
    }
};

window.refreshCart = async () => {
  try {
    window.disableCheckout(); 
    const res = await fetch('/');
    if (!res.ok) throw new Error(`HTTP ${res.status}`);

    const responseText = await res.text();
    const html = new DOMParser().parseFromString(responseText, 'text/html');

    const countEl = html.querySelector('.cart-bubble__text-count');
    const count = parseInt(countEl?.textContent?.trim() || '0', 10);

    console.log("cartRefresh called:", {html, count, countEl});
    console.log("count<><><><>",count);

    const selectors = ['.cart-drawer__inner'];

    for (const selector of selectors) {
      const target = document.querySelector(selector);
      const source = html.querySelector(selector);
    if (target && source) {
        target.replaceWith(source.cloneNode(true));
      }
    }
    document.querySelectorAll('#cart-bubble-text').forEach(el => {
        console.log("Element:", el, "Visible:", !!(el.offsetWidth || el.offsetHeight));
      el.textContent = count;
      el.classList.toggle('hidden', count <= 0);
    });
      window.enableCheckout(); 
  } catch (error) {
    console.error('Error refreshing cart:', error);
  } 
};


window.disableCheckout = async () =>{
  const btn = document.querySelector('#checkout');
  btn.setAttribute('disabled', true);
  console.log("checkout disabled");
}

 window.enableCheckout = async () =>{
  const btn = document.querySelector('#checkout');
  btn.removeAttribute('disabled');
  console.log("checkout enables");
}

document.addEventListener('DOMContentLoaded', function () {
  window.updatePrice();
  // window.collectionCustomFilter();
  if (typeof window.freeGift === "function") {
    window.freeGift();
  }

});


window.equalizeCardLinks = function () {
    const links = document.querySelectorAll(
      ".card-information .card-information__text a"
    );

    if (!links.length) return;

    let maxHeight = 0;

    // reset
    links.forEach(el => el.style.height = "auto");

    // get max height
    links.forEach(el => {
      maxHeight = Math.max(maxHeight, el.offsetHeight);
    });

    // apply
    links.forEach(el => {
      el.style.height = maxHeight + "px";
    });
  }

  window.addEventListener("load", window.equalizeCardLinks);
  window.addEventListener("resize", window.equalizeCardLinks);








